import * as React from "react";

import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import "../css/style.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // На телефоне (около 400 CSS-пикселей ширины) фиксированные 600 не помещались:
  // окно уезжало за оба края, и от заголовка оставалась середина строки — со стороны
  // это выглядело как полоса с обрывком текста, а не как список помещений.
  width: "min(600px, calc(100vw - 32px))",
  maxHeight: "calc(100vh - 32px)",
  overflowY: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};


export default function BldInfo(props) {
  const { handleClose, data, id, name, open, text_rooms, text_empty } = props;

  const rooms = (data || []).filter((e) => e.building_id == id);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          {/* Название площадки в заголовке: без него окно не объясняло, к чему список. */}
          {name && (
            <Typography variant="h6" component="h2">
              {name}
            </Typography>
          )}

          <Typography
            id="transition-modal-title"
            variant="subtitle1"
            component="h3"
          >
            {text_rooms}:
          </Typography>

          {rooms.map((e) => (
            <Typography
              id="transition-modal-description"
              sx={{ mt: 2 }}
              style={{ whiteSpace: "pre-wrap" }}
            >
              {e.number}
            </Typography>
          ))}

          {/* Пустой список выглядел как пустое окно без причины. */}
          {rooms.length === 0 && (
            <Typography sx={{ mt: 2 }} style={{ opacity: 0.7 }}>
              {text_empty}
            </Typography>
          )}

          
        </Box>
      </Fade>
    </Modal>
  );
}
